import React, {useState} from 'react';

import BlastreamTopBarLang from './BlastreamTopBarLang';

import CuultLogo from 'assets/logos-cuult/logo-cuult-blanc.svg';

import './BlastreamTopBar.scss';

const BlastreamTopBar = () => {
  const [roomLang, setRoomLang] = useState(localStorage.getItem('roomLang') || 'fr-FR');

  return (
    <div className="cuult-banner">
      <img src={CuultLogo} className="cuult-logo" alt="logo" />

      <div className="cuult-banner-right">
        <BlastreamTopBarLang roomLang={roomLang} setRoomLang={setRoomLang} />
      </div>
    </div>
  );
};

export default BlastreamTopBar;
